import axios from 'axios';

// Define types for authentication
interface LoginCredentials {
  email: string;
  password: string;
}

interface RegisterData {
  email: string;
  password: string;
  name?: string;
  company: string; // Changed from company_name to company
}

// Use the React environment variable format
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

class AuthService {
  async login(credentials: LoginCredentials) {
    const response = await axios.post(`${API_URL}/login`, credentials);
    if (response.data && response.data.token) {
      // Only store if we have valid data
      localStorage.setItem('user', JSON.stringify(response.data));
      localStorage.setItem('authToken', response.data.token);
    }
    return response.data;
  }

  async register(data: RegisterData) {
    const response = await axios.post(`${API_URL}/register`, data);
    return response.data;
  }

  async forgotPassword(email: string) {
    const response = await axios.post(`${API_URL}/forgot-password`, { email });
    return response.data;
  }

  logout() {
    localStorage.removeItem('user');
  }

  getCurrentUser() {
    const userStr = localStorage.getItem('user');
    if (userStr) return JSON.parse(userStr);
    return null;
  }
}

export const authService = new AuthService();